const PENDING_KEY = "ucExamSimulationPendingSubmissions";

const apiUrl = (path) => `${process.env.REACT_APP_API_BASE_URL}${path}`;

const authHeaders = () => {
  const token = window.localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const request = async (path, options = {}) => {
  const response = await fetch(apiUrl(path), {
    ...options,
    headers: { ...authHeaders(), ...(options.headers || {}) },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.message || "Exam simulation request failed.");
  }
  return payload;
};

export const trackExamSimulationVisit = (slug) =>
  request(`/api/exam-simulations/${encodeURIComponent(slug)}/visits`, {
    method: "POST",
    body: "{}",
  });

export const loadExamSimulationQuestions = (slug) =>
  request(`/api/exam-simulations/${encodeURIComponent(slug)}/questions`, {
    method: "GET",
  });

export const startExamSimulationAttempt = (slug, details) =>
  request(`/api/exam-simulations/${encodeURIComponent(slug)}/attempts`, {
    method: "POST",
    body: JSON.stringify(details),
  });

export const submitExamSimulationAttempt = (slug, attemptId, result) =>
  request(
    `/api/exam-simulations/${encodeURIComponent(slug)}/attempts/${encodeURIComponent(attemptId)}/submit`,
    {
      method: "PUT",
      body: JSON.stringify(result),
    }
  );

export const queueExamSimulationSubmission = (submission) => {
  try {
    const current = JSON.parse(window.localStorage.getItem(PENDING_KEY) || "[]");
    const queue = Array.isArray(current) ? current : [];
    const withoutDuplicate = queue.filter(
      (item) => item.attemptId !== submission.attemptId
    );
    window.localStorage.setItem(
      PENDING_KEY,
      JSON.stringify([...withoutDuplicate, submission].slice(-20))
    );
  } catch (_) {
    // A score is still shown locally when browser storage is unavailable.
  }
};

export const flushPendingExamSimulationSubmissions = async () => {
  let queue = [];
  try {
    const parsed = JSON.parse(window.localStorage.getItem(PENDING_KEY) || "[]");
    queue = Array.isArray(parsed) ? parsed : [];
  } catch (_) {
    return;
  }
  if (!queue.length) return;

  const remaining = [];
  for (const submission of queue) {
    try {
      await submitExamSimulationAttempt(
        submission.slug,
        submission.attemptId,
        submission.result
      );
    } catch (_) {
      remaining.push(submission);
    }
  }
  try {
    if (remaining.length) {
      window.localStorage.setItem(PENDING_KEY, JSON.stringify(remaining));
    } else {
      window.localStorage.removeItem(PENDING_KEY);
    }
  } catch (_) {
    // Ignore storage cleanup failures.
  }
};
